'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function ScrollHandler() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash) {
      const targetId = window.location.hash;
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        setTimeout(() => {
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offset = 100; // Header offset
          
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
          });
        }, 500);
      }
    }
  }, [pathname]);

  return null; // Ye kuch render nahi karega, sirf logic chalayega
}